import { getProjectAttributes, projectId } from "@bkry/bowline-redux/projects";
import {
  confirmWallet,
  sendWalletConfirmation,
  confirmErrorResetWallet,
} from "@bkry/bowline-redux/wallets";
import { useWeb3React } from "@web3-react/core";
import PropTypes from "prop-types";
import React, { useState } from "react";
import ReactCodeInput from "react-code-input";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const EmailConfirmationModal = ({ isOpen, toggle }, context) => {
  const { account } = useWeb3React();
  const dispatch = useDispatch();

  const currentProjectId = useSelector((state) => projectId(state));

  const projectData = useSelector((state) =>
    getProjectAttributes(state, currentProjectId)
  );

  const projectConstants = useSelector((state) => state.constants.project);

  const invalidResendMessage = useSelector(
    (state) => state.wallets.sendConfirmationError?.message
  );

  const invalidConfirmationMessage = useSelector(
    (state) => state.wallets.confirmErrorMessage
  );

  const [confirmationCode, setConfirmationCode] = useState("");

  const handleConfirmationChange = (e) => {
    setConfirmationCode(e);
  };

  const verifyConfirmationCode = () => {
    dispatch(
      confirmWallet({
        account,
        confirmationCode,
        projectId: currentProjectId,
        errorCallbackFnc: () => {
          setTimeout(() => {
            dispatch(confirmErrorResetWallet());
          }, 3000);
        },
      })
    );

    setConfirmationCode("");
  };

  return (
    <Modal isOpen={isOpen} centered>
      <ModalHeader>{context.t("Verify your e-mail address")}</ModalHeader>
      <ModalBody>
        <p>
          <span>{context.t("The code was sent to your e-mail")}.</span>
        </p>

        <p>{context.t("Please enter the code")}.</p>

        <ReactCodeInput
          isValid={!invalidConfirmationMessage}
          type="text"
          fields={6}
          value={confirmationCode}
          onChange={handleConfirmationChange}
        />
        {invalidResendMessage && (
          <p className="text-danger mt-3">{invalidResendMessage}</p>
        )}
        {invalidConfirmationMessage && (
          <p className="text-danger mt-3">{invalidConfirmationMessage}</p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={verifyConfirmationCode}>
          {context.t("Verify")}
        </Button>{" "}
        <Button
          color="secondary"
          onClick={() =>
            dispatch(
              sendWalletConfirmation({ account, projectId: currentProjectId })
            )
          }
        >
          {context.t("Resend")}
        </Button>
        {projectData?.bowline_connect_mode !==
          projectConstants.bowlineConnectMode.doubleOptIn && (
          <Button color="secondary" outline onClick={toggle}>
            {context.t("Discard")}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

EmailConfirmationModal.contextTypes = {
  t: PropTypes.func,
};

EmailConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default EmailConfirmationModal;
